import {
  Box,
  Button,
  MenuItem,
  Select,
  Tab,
  TextField,
  Typography,
  styled,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./style.scss";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import backIcon from "../../assets/images/backIcon.svg";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import {
  getOutstandingCommission,
  getPayoutAccounts,
  getPayoutList,
  requestPayout,
} from "../../store/reducers/payoutReducer";
import { dollarUS } from "../../utilities/formatters";
import CombinedPopup from "../../components/Popups/CombinedPopup";
import DailogBox from "../../components/ReusableComponents/DailogBox";
import { useFormik } from "formik";
import * as Yup from "yup";

const RequestPayout = (props) => {
  const { close } = props;
  const [submitOpen, setSubmitOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const { payoutAccess, payout_list } = useSelector((state) => state.payout);

  const [tabValue, setTabValue] = useState(
    payoutAccess ? "Profit Share" : "Affiliate Share"
  );
  const [openDBox, setOpenDBox] = useState(false);
  const [closeTradesAgreement, setCloseTradesAgreement] = useState(false);
  const dispatch = useDispatch();
  const { aff_commission } = useSelector((state) => state.payout);
  const [accounts, setAccounts] = useState([]);
  // Pop up states
  // success/ error modal
  const [ShowPopup, setShowPopup] = useState(false);
  const [CombinedPUHead, setCombinedPUHead] = useState("");
  const [CombinedPUBody, setCombinedPUBody] = useState("");
  const [PopUpType, setPopUpType] = useState("");

  useEffect(() => {
    dispatch(getPayoutAccounts()).then((res) => {
      if (res.accounts) setAccounts(res.accounts);
    });
  }, [dispatch]);

  useEffect(() => {
    if (true) {
      dispatch(getPayoutList());
      dispatch(getOutstandingCommission());
    }
  }, [dispatch]);

  const SubmitHandleClose = () => {
    setSubmitOpen(false);
    close(false);
  };

  // Formik initial values
  const initialValues = {
    login_id: "",
    amount: "",
    reason: "",
  };

  // Yup validation schema
  const validationSchema = Yup.object().shape({
    login_id:
      tabValue === "Profit Share"
        ? Yup.string().required("Account Login ID is required")
        : Yup.string(),
    amount:
      tabValue === "Profit Share"
        ? Yup.number()
            .typeError("Amount must be a number")
            .required("Amount is required")
            .positive("Amount must be a positive value")
            .min(80, "Amount must be at least $80")
        : Yup.number()
            .typeError("Amount must be a number")
            .required("Amount is required")
            .positive("Amount must be a positive value"),
    reason: Yup.string().max(150, "Reason must be at most 150 characters long"),
  });

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      const payload = {
        amount: values.amount,
        reason: values.reason,
      };
      if (tabValue === "Profit Share") {
        payload["login_id"] = values.login_id;
        payload["type"] = "Profit Share";
      } else if (tabValue === "Affiliate Share") {
        payload["type"] = "Affiliate Share";
      }
      dispatch(requestPayout(payload))
        .then((res) => {
          setCloseTradesAgreement(false);
          setShowPopup(true);
          setCombinedPUHead("Woo hoo !");
          setCombinedPUBody("Payout requested successfully!");
          setPopUpType("success");
          dispatch(getPayoutList());
        })
        .catch((err) => {
          setCloseTradesAgreement(false);
          console.log(err, "errerrerrerr");
          let msg = "Payout request failed!";
          if (err) {
            // Handle new error structure with message.non_field_errors
            if (
              err.message &&
              err.message.non_field_errors &&
              err.message.non_field_errors.length > 0
            ) {
              msg = err.message.non_field_errors[0];
            } else if (err.detail) {
              msg = err.detail;
            } else if (err[0]) {
              msg = err[0];
            }
          }
          setShowPopup(true);
          setCombinedPUHead("Oh snap !");
          setCombinedPUBody(msg);
          setPopUpType("error");
        })
        .finally(() => setSubmitting(false));
    },
  });

  const tabsHandleChange = (event, newValue) => {
    event.preventDefault();
    setTabValue(newValue);
  };

  //Custom Radio buttons
  const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: "50%",
    width: 20,
    height: 20,
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 0 0 1px rgb(16 22 26 / 40%)"
        : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: theme.palette.mode === "dark" ? "#394b59" : "#f5f8fa",
    backgroundImage:
      theme.palette.mode === "dark"
        ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
        : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: theme.palette.mode === "dark" ? "#30404d" : "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background:
        theme.palette.mode === "dark"
          ? "rgba(57,75,89,.5)"
          : "rgba(206,217,224,.5)",
    },
  }));

  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: "#04D9FF",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 20,
      height: 20,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  });

  const handlePopUp = () => {
    setOpenDBox(true);
  };

  const handleAgree = (e) => {
    console.log("Agree");
    setOpenDBox(false);
    formik.handleSubmit();
  };

  return (
    <div>
      <CombinedPopup
        type={PopUpType}
        trigger={ShowPopup}
        setTrigger={setShowPopup}
        head={CombinedPUHead}
        subhead={CombinedPUBody}
        onClick={SubmitHandleClose}
      />
      <DailogBox
        open={openDBox}
        setOpen={setOpenDBox}
        title={`Please note: All open trades on account ${formik.values.login_id} will be closed if any and the account will be disabled until the your request is reviewed. Click ok continue.`}
        handleAgree={handleAgree}
      />

      <div
        className="DpboxCon"
        style={{ marginTop: "24px", border: 0, padding: 0 }}
      >
        <Typography className="payout-heading">
          <img
            className="backIcon"
            src={backIcon}
            alt="BackIcon"
            style={{ cursor: "pointer" }}
            onClick={() => {
              close(false);
            }}
          />
          Back
        </Typography>
      </div>
      <Grid2
        xs={12}
        md={12}
        container
        item
        className="gen-info-form"
        spacing={3}
      >
        <Grid2 className="requestPayout-wrapper" item xs={7} md={9} lg={9}>
          <div className="form-grp-in">
            <div
              className="container-box payoutCnt"
              style={{ padding: "20px" }}
            >
              <div className="heading_section">
                <Typography className="payout-heading">
                  Request a New Payout
                </Typography>
                <Typography className="payout-subHeading">
                  Please use this form to request a new payment; we will check
                  and <br></br>contact you for additional information.
                </Typography>
              </div>

              <Box
                className="ContainerTab form_section__"
                sx={{ width: "100%", padding: "0", marginTop: "20px" }}
                p={3}
              >
                <TabContext value={tabValue}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList
                      className="buttonContainer"
                      onChange={tabsHandleChange}
                      aria-label="lab API tabs example"
                    >
                      <Tab
                        className="ContainertabName"
                        label="Trading Account"
                        value="Profit Share"
                        style={{
                          pointerEvents: !payoutAccess ? "none" : "auto",
                          backgroundColor: !payoutAccess && "#8f8f8f",
                        }}
                      />
                      <Tab
                        className="ContainertabName"
                        label="Affiliate"
                        value="Affiliate Share"
                      />
                    </TabList>
                  </Box>
                  <TabPanel style={{ padding: "0px" }} value="Profit Share">
                    <Grid2 item container gap={"20px"}>
                      <Grid2 item xs={12}>
                        <Typography className="payout-subHeading">
                          Please note*: Accounts in the below dropdown will
                          populate only on their respective withdrawal dates.
                        </Typography>
                      </Grid2>
                      <div className="req_payout_input_wrapper">
                        <Grid2 item xs={12} md={6} className="wrapperDiv">
                          <div className="form-grp-in">
                            <Typography
                              htmlFor="modalcity"
                              className="input-label light_mode_p"
                            >
                              Choose Account Login ID*
                            </Typography>
                            <Select
                              className="form-modal-select selectDiv_"
                              style={{
                                border: "transparent",
                                background: "#010101",
                              }}
                              name="login_id"
                              value={formik.values.login_id}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.login_id &&
                                Boolean(formik.errors.login_id)
                              }
                            >
                              {accounts.length > 0 ? (
                                accounts.map((account) => (
                                  <MenuItem
                                    value={account}
                                    className="select_innerDiv"
                                    key={account}
                                  >
                                    {account}
                                  </MenuItem>
                                ))
                              ) : (
                                <MenuItem className="select_innerDiv">
                                  No Options
                                </MenuItem>
                              )}
                            </Select>
                            {formik.touched.login_id &&
                              formik.errors.login_id && (
                                <div className="error-message">
                                  {formik.errors.login_id}
                                </div>
                              )}
                          </div>
                        </Grid2>
                        <Grid2 item xs={12} md={6}>
                          <div className="form-grp-in">
                            <Typography
                              htmlFor="recipientAddress"
                              className="input-label light_mode_p"
                            >
                              Withdraw Amount
                            </Typography>
                            <input
                              required
                              type="text"
                              className="input-modal reqPayoutInput"
                              id="recipient-address"
                              name="amount"
                              style={{ backgroundColor: "#" }}
                              value={formik.values.amount}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.touched.amount && formik.errors.amount && (
                              <div className="error-message">
                                {formik.errors.amount}
                              </div>
                            )}
                          </div>
                        </Grid2>
                      </div>
                      <Grid2 item xs={12} md={12}>
                        <div className="form-grp-in">
                          <Typography
                            htmlFor="recipientAddress"
                            className="input-label light_mode_p"
                          >
                            Reason
                          </Typography>
                          <TextField
                            className="request-payout-textarea"
                            sx={{ input: { color: "#fff" } }}
                            style={{
                              border: "none",
                              background:
                                "var(--Inner---inner-box, rgba(159, 159, 159, 0.05)) !important",
                              textAlign: "left",
                              color: "#fff",
                              borderRadius: "10px",
                              overflow: "hidden",
                            }}
                            hintText="Message Field"
                            multiline
                            rows={4}
                            name="reason"
                            value={formik.values.reason}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={
                              formik.touched.reason &&
                              Boolean(formik.errors.reason)
                            }
                          />
                          {formik.touched.reason && formik.errors.reason && (
                            <div className="error-message">
                              {formik.errors.reason}
                            </div>
                          )}
                        </div>
                      </Grid2>
                      <Grid2 item xs={6} md={4}>
                        <div
                          className="form-grp-in"
                          onClick={handlePopUp}
                          style={{ cursor: "pointer" }}
                        >
                          <Button
                            disabled={
                              (accounts && !accounts.length) ||
                              formik.isSubmitting ||
                              aff_commission < 0
                            }
                            className="payout-button"
                            style={{ color: "#ffffff", background: "#0D56EB" }}
                          >
                            Submit
                          </Button>
                        </div>
                      </Grid2>
                    </Grid2>
                  </TabPanel>
                  <TabPanel style={{ padding: "0px" }} value="Affiliate Share">
                    <form onSubmit={formik.handleSubmit} autoComplete="off">
                      <Grid2 item container gap={"20px"}>
                        <Grid2 item xs={12}>
                          {aff_commission < 100 && (
                            <Typography className="payout-subHeading">
                              Please note*:{" "}
                              <span className="error-message">
                                Minimum available commission to withdraw is $100
                              </span>
                            </Typography>
                          )}
                        </Grid2>
                        <div className="req_payout_input_wrapper">
                          <Grid2 item xs={12} md={6}>
                            <div className="form-grp-in">
                              <Typography
                                htmlFor="modalcity"
                                className="input-label"
                              >
                                Amount Withdraw
                              </Typography>
                              <input
                                required
                                type="text"
                                className="input-modal"
                                style={{
                                  border: "none",
                                  background: "#222C3A",
                                }}
                                id="recipient-address"
                                name="amount"
                                value={formik.values.amount}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                              {formik.touched.amount &&
                                formik.errors.amount && (
                                  <div className="error-message">
                                    {formik.errors.amount}
                                  </div>
                                )}
                            </div>
                          </Grid2>
                          <Grid2 item xs={12} md={6}>
                            <div className="form-grp-in">
                              <Typography
                                htmlFor="recipientAddress"
                                className="input-label"
                              >
                                Available Amount
                              </Typography>
                              <input
                                required
                                disabled
                                type="text"
                                className="input-modal"
                                style={{
                                  border: "none",
                                  background: "#222C3A",
                                }}
                                id="recipient-address"
                                value={dollarUS(aff_commission)}
                              />
                            </div>
                          </Grid2>
                        </div>
                        <Grid2 item xs={12} md={12}>
                          <div className="form-grp-in">
                            <Typography
                              htmlFor="recipientAddress"
                              className="input-label"
                            >
                              Reason
                            </Typography>
                            <TextField
                              style={{
                                border: "none",
                                textAlign: "left",
                              }}
                              className="requestpayout-textfield"
                              hintText="Message Field"
                              multiline
                              rows={4}
                              name="reason"
                              value={formik.values.reason}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={
                                formik.touched.reason &&
                                Boolean(formik.errors.reason)
                              }
                            />
                            {formik.touched.reason && formik.errors.reason && (
                              <div className="error-message">
                                {formik.errors.reason}
                              </div>
                            )}
                          </div>
                        </Grid2>
                        <Grid2 item xs={6} md={4}>
                          <div className="form-grp-in">
                            <Button
                              type="submit"
                              disabled={
                                aff_commission < 100 ||
                                aff_commission < 0 ||
                                formik.isSubmitting
                              }
                              className="payout-button"
                              style={{
                                color: "#ffffff",
                                background: "rgb(13, 86, 235)",
                              }}
                            >
                              Submit
                            </Button>
                          </div>
                        </Grid2>
                      </Grid2>
                    </form>
                  </TabPanel>
                </TabContext>
              </Box>
            </div>
          </div>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default RequestPayout;
